/**
 * Session code generation utilities
 *
 * Provides a function to generate random session codes using unambiguous characters.
 */

/**
 * Generate a random 4-character session code using unambiguous characters
 *
 * Excludes characters that can be confused visually (0, O, 1, I).
 *
 * @returns A 4-character uppercase alphanumeric session code
 */
export function generateSessionCode(): string {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let code = '';
  for (let i = 0; i < 4; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
}

/**
 * Build the deep-link URL a player can use to join a session directly
 *
 * Uses window.location.origin so the URL is correct in any deployment environment.
 *
 * @param sessionCode - The session code to embed in the URL
 * @returns Fully-qualified URL string, or empty string if sessionCode is blank
 */
export function buildJoinUrl(sessionCode: string): string {
  if (!sessionCode.trim()) {
    console.warn('[SESSION_CODE] buildJoinUrl called with empty sessionCode', {
      context: 'buildJoinUrl',
      fallbackValue: ''
    });
    return '';
  }
  return `${window.location.origin}/?code=${encodeURIComponent(sessionCode)}`;
}
